<template>
  <div class="container">
    <v-card>
      <v-toolbar class="mt-12" dark color="primary">
        <v-toolbar-title>Buscar Turnos</v-toolbar-title>
      </v-toolbar>

      <v-form ref="form" v-model="valid" :lazy-validation="lazy">
        <v-card-text>
          <v-row>
            <v-col cols="12">
              <v-chip label color="transparent" text-color="black">
                <h3>Búsqueda de Turnos</h3>
              </v-chip>
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="12" md="3" sm="4">
              <v-select
                :items="profsBuscar"
                item-text="nombre"
                item-value="idCancha"
                menu-props="auto"
                label="Cancha"
                hide-details
                prepend-icon="mdi-account"
                v-model="prof"
                dense
                no-data-text="No hay canchas registradas"
              ></v-select>
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="12" sm="4" md="3">
              <v-text-field
                v-model="fechaDesde"
                :value="fechaDesde"
                label="Fecha Desde"
                :rules="requiredRules"
                prepend-icon="mdi-calendar"
                type="date"
                dense
              ></v-text-field>
            </v-col>
            <v-col cols="12" sm="4" md="3">
              <v-text-field
                v-model="fechaHasta"
                :value="fechaHasta"
                :rules="requiredRules"
                label="Fecha Hasta"
                prepend-icon="mdi-calendar"
                type="date"
                dense
              ></v-text-field>
            </v-col>
            <v-col cols="12" sm="4" md="3">
              <v-select
                :items="estados"
                v-model="estadoTurno"
                item-text="estadoTurno"
                item-value="estadoTurno"
                label="Estado Turno"
                dense
                prepend-icon="mdi-calendar-multiple"
              ></v-select>
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="12" sm="4" md="3">
              <v-text-field
                v-model="dni"
                prepend-icon="mdi-account"
                label="D.N.I"
                dense
                @keypress="onlyNumber"
                maxlength="9"
              ></v-text-field>
            </v-col>
            <v-col cols="12" sm="4" md="3">
              <v-text-field
                v-model="apellidos"
                prepend-icon="mdi-account"
                label="Apellidos Jugador"
                maxlength="50"
                dense
              ></v-text-field>
            </v-col>
            <v-col cols="12" sm="4" md="3">
              <v-text-field
                v-model="nombres"
                prepend-icon="mdi-account"
                label="Nombres Jugador"
                maxlength="50"
                dense
              ></v-text-field>
            </v-col>
          </v-row>
        </v-card-text>
      </v-form>
      <v-card-actions class="mt-0 pt-0">
        <v-spacer></v-spacer>
        <v-btn
          :disabled="isLoading"
          :loading="isLoading"
          color="primary"
          @click.stop="handleBuscarTurnos"
        >
          Buscar
          <v-icon dark right>mdi-magnify</v-icon>
        </v-btn>
      </v-card-actions>

      <v-data-table
        v-show="listaTurnos.length"
        :headers="
          $store.state.usuario.institucion.esEmpresa ? headersEmpresa : headers
        "
        :items="this.listaTurnos"
        class="elevation-1"
        locale="es-ar"
        item-key="idTurno"
        :items-per-page="10"
        disable-sort
        disable-filtering
        :server-items-length="cantRegistros"
        :loading="isLoading"
        ref="myTable"
        :footer-props="{
          itemsPerPageText: 'Filas por página',
          itemsPerPageOptions: [5, 10, 15],
        }"
        :options.sync="options"
      >
        <template v-slot:item.totalConsumoTurno="{ item }">
          <span v-if="item.totalConsumoTurno && item.totalConsumoTurno !== '—'">
            {{ item.totalConsumoTurno }}
          </span>
          <span v-else class="grey--text">—</span>
        </template>
      </v-data-table>
      <v-alert
        class="mt-4"
        color="purple"
        dark
        outlined
        v-if="!listaTurnos.length"
      >
        No hay turnos que coincidan con los filtros de búsqueda.
      </v-alert>
      <v-card-actions>
        <v-btn dark color="#24232d" @click="salir">
          <v-icon left>mdi-arrow-left</v-icon>
          Volver
        </v-btn>

        <v-spacer></v-spacer>
        <v-btn
          color="success"
          :disabled="listaTurnos.length < 1"
          @click.stop="exportar"
        >
          <v-icon left class="mx-1">mdi-microsoft-excel</v-icon>
          Exportar a Excel</v-btn
        >
        <v-btn
          color="warning"
          :disabled="listaTurnos.length < 1"
          @click.stop="imprimir"
        >
          Imprimir</v-btn
        >
      </v-card-actions>
      <SeleccionarTipoImpresion
        :visible="showSeleccionarTipoImpresion"
        :listaTurnos="listaTurnosImprimir"
        :fechaDesde="fechaDesde"
        :fechaHasta="fechaHasta"
        :esEliminado="false"
        :profesional="prof"
        @close="showSeleccionarTipoImpresion = false"
      ></SeleccionarTipoImpresion>
    </v-card>
  </div>
</template>
<style scoped>
::v-deep .v-data-table__empty-wrapper {
  display: none;
}
.container {
  margin: auto;
}
</style>
<script>
import axios from "@/axios-auth";
import router from "@/router";
import SeleccionarTipoImpresion from "./SeleccionarTipoImpresion.vue";
export default {
  data: (vm) => ({
    valid: false,
    lazy: false,
    dni: null,
    apellidos: null,
    nombres: null,
    requiredRules: [(v) => !!v || "Dato obligatorio"],
    prof: 0,
    profsBuscar: [],
    listaTurnos: [],
    listaTurnosImprimir: [],
    obrasSociales: [],
    obraSocial: 0,
    headers: [
      { text: "Dia", value: "diaSemana" },
      { text: "Fecha", value: "fechaTurnoString" },
      { text: "Hora", value: "horaInicioString", sortable: false },
      { text: "Dni", value: "dniPaciente" },
      { text: "Jugador", value: "nombrePaciente" },
      { text: "Telefono", value: "celular" },
      { text: "Cancha", value: "nombreCancha" },
      { text: "Valor Turno", value: "totalConsumoTurno" },
      { text: "Observaciones", value: "observacionesTurno" },
      { text: "Estado", value: "estadoTurnoString" },
    ],
    headersEmpresa: [
      { text: "Dia", value: "diaSemana" },
      { text: "Fecha", value: "fechaTurnoString" },
      { text: "Hora", value: "horaInicioString", sortable: false },
      { text: "Dni", value: "dniPaciente" },
      { text: "Jugador", value: "nombrePaciente" },
      { text: "Telefono", value: "celular" },
      { text: "Cancha", value: "nombreCancha" },
      { text: "Valor Turno", value: "totalConsumoTurno" },
      { text: "Observaciones", value: "observacionesTurno" },
      { text: "Estado", value: "estadoTurnoString" },
    ],
    fechaDesde: null,
    fechaHasta: null,
    estados: ["TODOS", "RESERVADO", "EN ESPERA", "JUGADO"],
    estadoTurno: "",
    showSeleccionarTipoImpresion: false,
    isLoading: false,
    options: {},
    cantRegistros: null,
    totalValorTurnos: 0,
    tiposTurno: [
      { value: 2, text: "TODOS" },
      { value: 0, text: "DADO EN LA INSTITUCION" },
      { value: 1, text: "TOMADO EN WEB" },
    ],
    tipoTurno: 2,
  }),
  watch: {
    options: {
      immediate: true,
      deep: true,
      handler(val) {
        if (Object.keys(val).length) {
          this.buscarTurnos();
        }
      },
    },
  },
  methods: {
    onlyNumber($event) {
      let keyCode = $event.keyCode ? $event.keyCode : $event.which;
      if (keyCode < 48 || keyCode > 57) {
        // 46 is dot
        $event.preventDefault();
      }
    },
    async exportar() {
      let estadoTur = 0;
      if (this.estadoTurno == "TODOS") estadoTur = 0;
      if (this.estadoTurno == "RESERVADO") estadoTur = 1;
      if (this.estadoTurno == "EN ESPERA") estadoTur = 2;
      if (this.estadoTurno == "JUGADO") estadoTur = 3;

      const params = {
        idInstitucion: this.$store.state.usuario.institucion.idInstitucion,
        fechaDesde: this.fechaDesde,
        fechaHasta: this.fechaHasta,
        dni: this.dni,
        apellidos: this.apellidos,
        nombres: this.nombres,
        idProfesional: this.prof,
        estadoTurno: estadoTur,
      };

      try {
        const response = await axios.post(
          `/Turnos/ExportarExcelTurnos`,
          params,
          {
            responseType: "arraybuffer", // 👈 clave: devuelve binario
          },
        );

        // Crear Blob con la respuesta
        const blob = new Blob([response.data], {
          type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
        });

        // Crear link de descarga temporal
        const url = window.URL.createObjectURL(blob);
        const link = document.createElement("a");
        link.href = url;

        // El backend ya manda un nombre, pero si querés podés definir el tuyo:
        const fileName = `Turnos-${this.fechaDesde}-${this.fechaHasta}.xlsx`;

        link.setAttribute("download", fileName);
        document.body.appendChild(link);
        link.click();

        // Limpiar referencias
        link.remove();
        window.URL.revokeObjectURL(url);

        console.log("Descarga completada ✅");
      } catch (error) {
        console.error("Error descargando Excel:", error);
      }
    },
    salir() {
      router.push({ path: "/Home" });
    },
    parseDate(date) {
      if (!date) return null;
      const [day, month, year] = date.split("/");
      return `${year}-${month.padStart(2, "0")}-${day.padStart(2, "0")}`;
    },
    toISOLocal(d) {
      var z = (n) => ("0" + n).slice(-2);
      var zz = (n) => ("00" + n).slice(-3);
      var off = d.getTimezoneOffset();
      var sign = off < 0 ? "+" : "-";
      off = Math.abs(off);
      return (
        d.getFullYear() +
        "-" +
        z(d.getMonth() + 1) +
        "-" +
        z(d.getDate()) +
        "T" +
        z(d.getHours()) +
        ":" +
        z(d.getMinutes()) +
        ":" +
        z(d.getSeconds()) +
        "." +
        zz(d.getMilliseconds()) +
        "Z"
      )
        .toString()
        .substr(0, 10);
    },
    formatDate(date) {
      if (!date) return null;
      const [year, month, day] = date.split("-");
      return `${day}/${month}/${year}`;
    },
    handleBuscarTurnos() {
      this.options.page = 1;
      this.buscarTurnos();
    },
    buscarTurnos() {
      this.isLoading = true;
      let estadoTur = 0;
      if (this.estadoTurno == "TODOS") estadoTur = 0;
      if (this.estadoTurno == "RESERVADO") estadoTur = 1;
      if (this.estadoTurno == "EN ESPERA") estadoTur = 2;
      if (this.estadoTurno == "JUGADO") estadoTur = 3;
      const filtrosData = {
        dni: this.dni,
        apellidos: this.apellidos,
        nombres: this.nombres,
        idInstitucion: this.$store.state.usuario.institucion.idInstitucion,
        fechaDesde: this.fechaDesde,
        fechaHasta: this.fechaHasta,
        idProfesional: this.prof,
        estadoTurno: estadoTur,
        page: this.options.page,
        items: this.options.itemsPerPage,
      };

      let self = this;
      axios
        .post("/Turnos/BuscarTurnos?", filtrosData)
        .then(function (response) {
          if (response.data != null && response.data != "") {
            self.listaTurnos = response.data.listaTurnos;
            self.cantRegistros = response.data.cantRegistros;
            self.cargarTotalesConsumoTurno();
          } else {
            self.listaTurnos = [];
          }
          self.isLoading = false;
        })
        .catch(function (error) {
          self.isLoading = false;
        });
    },
    async cargarTotalesConsumoTurno() {
      if (!this.listaTurnos.length) return;
      const ids = this.listaTurnos.map((t) => t.idTurno).filter((id) => id > 0);
      if (!ids.length) return;
      try {
        const { data } = await axios.post("/Caja/ObtenerTotalesConsumoTurno", ids);
        if (data && Array.isArray(data)) {
          const mapa = {};
          let sumaTotal = 0;
          data.forEach((item) => {
            mapa[item.idTurno] = item.totalConsumoTurno;
            sumaTotal += item.totalConsumoTurno;
          });
          this.totalValorTurnos = sumaTotal;
          this.listaTurnos.forEach((turno) => {
            this.$set(turno, "totalConsumoTurno", mapa[turno.idTurno] ? `$${mapa[turno.idTurno].toFixed(2)}` : "—");
          });
        }
      } catch (e) {
        console.error("Error cargando totales consumo turno:", e);
      }
    },
    imprimir() {
      var estadoTur = 0;
      if (this.estadoTurno == "TODOS") estadoTur = 0;
      if (this.estadoTurno == "RESERVADO") estadoTur = 1;
      if (this.estadoTurno == "EN ESPERA") estadoTur = 2;
      if (this.estadoTurno == "JUGADO") estadoTur = 3;
      const filtrosData = {
        dni: this.dni,
        apellidos: this.apellidos,
        nombres: this.nombres,
        idInstitucion: this.$store.state.usuario.institucion.idInstitucion,
        fechaDesde: this.fechaDesde,
        fechaHasta: this.fechaHasta,
        idProfesional: this.prof,
        estadoTurno: estadoTur,
        idObraSocial: this.obraSocial,
        tipoTurno: this.tipoTurno,
        page: -1,
        items: -1,
      };

      let self = this;
      axios
        .post("/Turnos/BuscarTurnos?", filtrosData)
        .then(async function (response) {
          self.listaTurnosImprimir = response.data.listaTurnos;
          // Cargar totales de consumo turno para la impresión
          if (self.listaTurnosImprimir && self.listaTurnosImprimir.length) {
            const ids = self.listaTurnosImprimir.map((t) => t.idTurno).filter((id) => id > 0);
            if (ids.length) {
              try {
                const { data } = await axios.post("/Caja/ObtenerTotalesConsumoTurno", ids);
                if (data && Array.isArray(data)) {
                  const mapa = {};
                  data.forEach((item) => { mapa[item.idTurno] = item.totalConsumoTurno; });
                  self.listaTurnosImprimir.forEach((turno) => {
                    turno.totalConsumoTurno = mapa[turno.idTurno] ? `$${mapa[turno.idTurno].toFixed(2)}` : "—";
                  });
                }
              } catch (e) { console.error(e); }
            }
          }
          self.showSeleccionarTipoImpresion = true;
        });
    },
  },
  created() {
    this.profsBuscar = [...this.$store.state.usuario.canchas].sort((a, b) =>
      a.nombre.localeCompare(b.nombre),
    );

    if (this.profsBuscar.length > 1) {
      this.profsBuscar.unshift({
        idCancha: 0,
        nombre: "TODOS",
      });
    }
    this.prof = this.profsBuscar[0].idCancha;

    this.fechaDesde = this.parseDate(
      this.formatDate(this.toISOLocal(new Date())),
    );
    this.fechaHasta = this.fechaDesde;
    this.estadoTurno = "TODOS";
  },
  mounted() {
    window.scrollTo({ top: 0, behavior: "smooth" });
  },
  components: {
    SeleccionarTipoImpresion,
  },
};
</script>
